<template>
  <div class="card">
    <div class="card-header">
      <p class="text-header mb-0">Gerenciar perfil</p>
    </div>
    <div class="card-body">
      <!-- PROFILE -->
      <div class="card">
        <div class="card-body">
          <div class="d-flex mb-3">
            <div class="position-relative">
              <AvatarComponent />
              <div
                class="position-absolute avatar-content w-100 p-3 bottom-0 start-0 end-0"
              >
                <div class="d-flex justify-content-between align-items-center">
                  <span class="badge bg-primary"
                    >R${{ session?.appointment_price }}</span
                  >
                  <img src="@/assets/img/youtube_icon.svg" />
                </div>
              </div>
            </div>
            <div class="ms-3">
              <span
                class="badge bg-success mb-2 rounded-4"
                v-if="session?.online"
              >
                Disponível agora
              </span>
              <p class="text-subtitle mb-2">
                {{ session?.name }}
              </p>
              <p class="text-label">
                CRP: {{ session?.crp }} | {{ session?.address_state }}
              </p>
            </div>
          </div>
          <p class="text-paragraph">
            {{ session?.bio }}
          </p>
          <div class="d-flex mb-4">
            <span class="border rounded-4 px-2 border-2 text-paragraph me-2">
              <i class="fa-solid fa-star text-warning"></i>
              {{ session?.ratings_as_psi_count }}
            </span>
            <span class="border rounded-4 px-2 border-2 text-paragraph">
              <i class="fa-solid fa-user-group"></i>
              {{ session?.valid_appointments_as_psi_count }}
            </span>
          </div>

          <hr class="my-3" />

          <div class="row">
            <div class="col-12 col-md-6">
              <Button
                label="Visualizar perfil"
                outline
                fullWidth
                @onClick="handleProfile"
              />
            </div>
            <div class="col-12 col-md-6">
              <Button
                label="Editar perfil"
                color="primary"
                fullWidth
                @onClick="handleProfileEdit"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- MELHORES SEU PERFIL -->
      <div class="card cursor-pointer" @click="handleImproveYourProfile">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <p class="mb-0 text-subtitle" :class="{ 'text-muted': !isPremium }">
              <i class="fa-solid fa-star"></i>
              Melhore seu perfil
            </p>
            <i class="fa-solid fa-chevron-right"></i>
          </div>
          <p class="text-paragraph" :class="{ 'text-muted': !isPremium }">
            Dicas para deixar seu perfil mais atrativo para os pacientes.
          </p>

          <div class="progress" v-if="isPremium">
            <div
              class="progress-bar bg-success"
              role="progressbar"
              :style="{
                width: `${session?.profile_improvement_values?.percentage}%`,
              }"
            ></div>
          </div>
          <p v-else class="text-subtitle text-info mb-0">
            Exclusivo para assinantes do Psiapp+
          </p>
        </div>
      </div>

      <!-- VISUALIZAÇÕES -->
      <div class="card">
        <div class="card-body">
          <p class="text-subtitle" :class="{ 'text-muted': !isPremium }">
            <i class="fa-solid fa-eye"></i>
            Visualizações
          </p>
          <p class="text-paragraph" :class="{ 'text-muted': !isPremium }">
            Quantidade de pacientes que visualizaram seu perfil.
          </p>
          <template v-if="isPremium">
            <div
              class="d-flex align-items-center justify-content-between border-bottom my-4"
            >
              <p class="text-paragraph">Últimos 30 dias</p>
              <p class="text-subtitle">
                {{ session?.total_views_this_month }}
              </p>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <p class="text-paragraph">Todas visualizações</p>
              <p class="text-subtitle">{{ session?.total_views }}</p>
            </div>
          </template>
          <p v-else class="text-subtitle text-info mb-0">
            Exclusivo para assinantes do Psiapp+
          </p>
        </div>
      </div>

      <!-- PSIAPP ADS -->
      <!-- <div class="card bg-warning-soft">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <img
              src="@/assets/img/psiapp_ads.svg"
              alt=""
              height="26"
              class="mb-3"
            />

            <p class="text-subtitle">Em breve</p>
          </div>
          <p class="text-paragraph">
            Alcance os pacientes onde eles estiverem e aumente ainda mais a
            visibilidade pro seu perfil.
          </p>
          <button class="btn btn-warning" @click="handlePsiappAds">
            Quero saber mais
          </button>
        </div>
      </div> -->

      <!-- ACTIONS -->
      <div
        class="d-flex align-items-center py-4 cursor-pointer"
        :class="{ 'border-bottom': index !== actions.length - 1 }"
        v-for="(action, index) in actions"
        :key="index"
        @click="action.action"
      >
        <p class="mb-0 text-paragraph">
          <i :class="action.icon" class="text-primary"></i>
          {{ action.label }}
        </p>
        <i class="fa-solid fa-chevron-right ms-auto text-primary"></i>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useMainStore } from "@/store";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import {
  EOffcanvasViews,
  IOffcanvasConfig,
  OffcanvasViewKey,
  OffcanvasViewsConfig,
  navigateCanvas,
} from "@/views/OffcanvasViews/OffcanvasViewsConfig";
import { computed } from "vue";

const { session } = useMainStore();

const isPremium = session?.is_plus;
const profileLink = `${process.env.VUE_APP_WEB_APP_URL}psi/${session?.slug}`;

const toggle = computed(() => window.innerWidth > 964);

const actions = [
  {
    icon: "fa-solid fa-user",
    label: "Visualizar meu perfil",
    action: () => navigate(OffcanvasViewsConfig.my_profile),
  },
  {
    icon: "fa-solid fa-globe",
    label: "Visualizar meu perfil na web",
    action: () => window.open(profileLink, "_blank"),
  },
  {
    icon: "fa-solid fa-user-pen",
    label: "Gerenciar e editar perfil",
    action: () => navigate(OffcanvasViewsConfig.profile_edit),
  },
  {
    icon: "fa-solid fa-share",
    label: "Compartilhar horário avulso",
    action: () => navigate(OffcanvasViewsConfig.share_schedule),
  },
  {
    icon: "fa-solid fa-share",
    label: "Compartilhar perfil",
    action: () => {
      navigator.clipboard.writeText(profileLink);
      EventBus.$emit(EventBusNames.SHOW_TOAST, {
        title: "Link copiado",
        msg: `O link de seu perfil foi copiado para você poder compartilhar`,
      });
    },
  },
];

const handlePsiappAds = () => {
  const phone = process.env.VUE_APP_WHATSAPP_NUMBER;
  const msg = process.env.VUE_APP_WHATSAPP_MESSAGE;
  const uri = `https://api.whatsapp.com/send?phone=${phone}&text=${msg}`;
  window.open(uri, "_blank");
};

const handleImproveYourProfile = () => {
  if (isPremium) {
    navigate(OffcanvasViewsConfig.improve_your_profile);
    return;
  }
  navigateCanvas(EOffcanvasViews.subscription);
};

const navigate = (view: IOffcanvasConfig) => {
  navigateCanvas(view.path as OffcanvasViewKey, null, toggle.value);
};

const handleProfile = () => {
  navigate(OffcanvasViewsConfig.my_profile);
};

const handleProfileEdit = () => {
  navigate(OffcanvasViewsConfig.profile_edit);
};
</script>

<style scoped>
.avatar-content {
  height: 40px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.avatar-xxl {
  width: 8rem;
  height: 8rem;
  font-size: 2.6666666667rem;
}
</style>
